const HERO_VAR = '--formal-team-campaign-hero-margin';

function syncFormalTeamCampaignHeroMargins() {
	document.querySelectorAll('.formal_team_campaign').forEach((root) => {
		const img = root.querySelector('.levcharity_hero_thumbnail--desktop');
		if (!img || !(img instanceof HTMLImageElement)) {
			return;
		}
		const h = img.offsetHeight;
		if (h > 0) {
			root.style.setProperty(HERO_VAR, `${h}px`);
		} else {
			root.style.removeProperty(HERO_VAR);
		}
	});
}

function initFormalTeamCampaignHeroLayout() {
	const imgs = document.querySelectorAll(
		'.formal_team_campaign .levcharity_hero_thumbnail--desktop',
	);
	if (!imgs.length) {
		return;
	}

	syncFormalTeamCampaignHeroMargins();

	imgs.forEach((img) => {
		if (!img.complete) {
			img.addEventListener('load', syncFormalTeamCampaignHeroMargins, { once: true });
		}
	});

	if (typeof ResizeObserver !== 'undefined') {
		const ro = new ResizeObserver(syncFormalTeamCampaignHeroMargins);
		imgs.forEach((img) => ro.observe(img));
	}
}

document.addEventListener('DOMContentLoaded', initFormalTeamCampaignHeroLayout, false);
